import React from 'react';
import 'Components/Utility/Skeleton/SkeletonFanFavouriteCardNew.scss';

const SkeletonFanFavouriteCardNew = () => (
  <div className="skeleton-fan-favourite-card">
    <div className="content-container">
      <div className="left-container">
        <div className="cover-container">
          <div className="skeleton-image" />
        </div>
        <div className="card-actions-container d-lg-none">
          <div className="skeleton-price" />
        </div>
      </div>
      <div className="right-container">
        <div className="skeleton-title" />
        <div className="skeleton-rating" />
        <div className="price-rating-container">
          <div className="skeleton-price" />
          <div className="skeleton-rating" />
        </div>

        <div className="tag-column-container">
          {[1, 2, 3].map(key => (
            <div key={key} className="skeleton-tag" />
          ))}
        </div>

        <div className="skeleton-review-text-xs" />
        <div className="skeleton-review-text-sm" />
        <div className="skeleton-review-text-md" />
        <div className="skeleton-review-text-lg" />
        <div className="skeleton-review-text-xl" />
        <div className="skeleton-review-text-xxl" />

        <div className="skeleton-full-review-link" />

        <div className="bottom-container">
          <div className="skeleton-display-name" />
          <div className="like-container">
            <div className="skeleton-helpful-message" />
            <div className="skeleton-like-button" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SkeletonFanFavouriteCardNew;
